export default "__VITE_ASSET__DPlWHrPB__"